<template>
  <ul class="space-y-4">
    <AreaForm
      v-for="(area, index) in value"
      :key="area.id"
      :value="area"
      :configurable="config[area.type].configurable"
      :label="config[area.type].label"
      @updated="$emit('updated', { index, area: $event })"
      @removed="$emit('removed', { index })"
    />
    <div
      v-if="isSelectingAreaType"
      class="grid grid-cols-2 gap-x-4 gap-y-2 items-center px-2 sm:px-5 py-5 rounded-b-sm bg-cream bg-opacity-50"
    >
      <label class="col-span-2 sm:col-span-1" for="coating-area-type-select"
        >What is your area?</label
      >
      <div class="col-span-2 sm:col-span-1">
        <SelectMenu
          id="coating-area-type-select"
          :options="areaTypeOptions"
          :value="null"
          test-id="area-type-select"
          placeholder="Choose..."
          @input="handleAreaTypeChange"
        >
        </SelectMenu>
      </div>
    </div>
    <AddButton v-else @click="isSelectingAreaType = true" />
  </ul>
</template>

<script>
import config from "../coatingAreaConfig";
import AddButton from "../ui/AddButton.vue";
import AreaForm from "../AreaForms/AreaForm.vue";
import SelectMenu from "../../ui/SelectMenu.vue";

export default {
  name: "AreaAccordion",

  components: { AddButton, AreaForm, SelectMenu },

  props: {
    options: {
      type: Array,
      required: true,
    },

    value: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      config,
      isSelectingAreaType: () => {
        return this.value.length === 0;
      },
    };
  },

  computed: {
    areaTypeOptions() {
      return this.options.map(({ value, label }) => ({ value, label }));
    },
  },

  methods: {
    handleAreaTypeChange(areaType) {
      this.$emit("added", { type: areaType });
      this.isSelectingAreaType = false;
    },
  },
};
</script>
